import { gql } from '@/services/api';

export const ContentFragment = gql`
  fragment ContentFragment on Collection {
    content(pagination: { after: $after }) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          product {
            id
            name
            isSaved
            category {
              id
              name
            }
            media {
              type
              source
            }
          }
          recommendation {
            id
            message
            user {
              id
              name
              nickname
            }
            media {
              source
              type
            }
          }
        }
      }
    }
  }
`;

export const CollectionFragment = gql`
  fragment CollectionFragment on Collection {
    id
    isPrivate
    name
    description
    owner {
      id
      name
      nickname
      lastname
      avatar
      email
      level {
        id
        name
      }
      isFollowed
    }
  }
`;
